import { render, staticRenderFns } from "./guestRemark.vue?vue&type=template&id=24d28e88&scoped=true"
import script from "./guestRemark.vue?vue&type=script&lang=js"
export * from "./guestRemark.vue?vue&type=script&lang=js"
import style0 from "./guestRemark.vue?vue&type=style&index=0&id=24d28e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d28e88",
  null
  
)

export default component.exports